// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"6471900b","453":"495b0fe9"}[chunkId] + ".chunk.js";
};